import { Card, CardContent, CardHeader, CardTitle, Link } from '@/components/ui'
import { getProjectPath } from '@/utils'
import type { CaseBilling } from './utils'

interface TopCasesCardProps {
  cases: CaseBilling[]
}

export function TopCasesCard({ cases }: TopCasesCardProps) {
  const maxPages = Math.max(
    ...cases.map((entry) => entry.project.numberOfPages),
    1,
  )

  return (
    <Card className="flex flex-col">
      <CardHeader>
        <CardTitle>Top cases by pages</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-1 flex-col justify-center">
        {cases.length === 0 ? (
          <p className="text-sm text-muted-foreground">
            No processed cases in this period.
          </p>
        ) : (
          <ol className="space-y-3.5">
            {cases.map((entry, index) => (
              <li key={entry.project.id} className="space-y-1.5">
                <div className="flex items-baseline justify-between gap-3">
                  <Link
                    to={getProjectPath(entry.project)}
                    className="flex min-w-0 items-baseline gap-2 hover:underline"
                  >
                    <span className="text-xs font-medium tabular-nums text-blue-4">
                      {index + 1}
                    </span>
                    <span className="truncate text-sm font-medium text-blue-7">
                      {entry.project.name}
                    </span>
                  </Link>
                  <span className="shrink-0 text-sm font-semibold tabular-nums text-blue-7">
                    {entry.project.numberOfPages.toLocaleString()} pg
                  </span>
                </div>
                <div className="h-1.5 overflow-hidden rounded-full bg-blue-2/50">
                  <div
                    className="h-full rounded-full bg-blue-5"
                    style={{
                      width: `${(entry.project.numberOfPages / maxPages) * 100}%`,
                    }}
                  />
                </div>
              </li>
            ))}
          </ol>
        )}
      </CardContent>
    </Card>
  )
}
